import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import {
    BASE_URL, getDefaultHeaders, getDynamicHeaders, Entity,
} from '../config';
import { ITextCommonContent, ITextFAQContent } from './types';

export const textAPI = createApi({
    reducerPath: 'text',
    baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
    endpoints: (build) => ({
        getFaq: build.query<ITextFAQContent[], void>({
            query: () => ({
                url: `${Entity.text}/faq`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getOffer: build.query<ITextCommonContent, void>({
            query: () => ({
                url: `${Entity.text}/oferta-website`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getPolicy: build.query<ITextCommonContent, void>({
            query: () => ({
                url: `${Entity.text}/privacyfooter`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getPolicyPage: build.query<ITextCommonContent, void>({
            query: () => ({
                url: `${Entity.text}/privacypolicy`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getCookies: build.query<ITextCommonContent, void>({
            query: () => ({
                url: `${Entity.text}/cookie`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getCookiesRequired: build.query<ITextCommonContent, void>({
            query: () => ({
                url: `${Entity.text}/cookie_1`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getCookiesOptional: build.query<ITextCommonContent, void>({
            query: () => ({
                url: `${Entity.text}/cookie_2`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getCookiesAnalytical: build.query<ITextCommonContent, void>({
            query: () => ({
                url: `${Entity.text}/cookie_3`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getCookiesRemark: build.query<ITextCommonContent, void>({
            query: () => ({
                url: `${Entity.text}/cookie_button`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getChatGreeting: build.query<ITextCommonContent, void>({
            query: () => ({
                url: `${Entity.text}/new_dialogue`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        // https://redmine.srvb.pro/issues/684418
        getAndroidOffer: build.query<ITextCommonContent, void>({
            query: () => ({
                url: `${Entity.text}/oferta-v-prilozhenii`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders(), 'x-device_by': 'android/0.0.0' },
            }),
        }),
    }),
});
